/* SHARED VARS */
var firstrun = true,
    touch = false,
    clickEv = 'click';


// handle quickshop position
function positionQuickshop() {

    if (touch == false) {
        var quickshops = $('.quick_shop');

        quickshops.each(function () {
            var parent = $(this).parents('.hoverBorder');
            $(this).css({
                'top': ((parent.height() / 2) - ($(this).outerHeight() / 2)) + 'px',
                'left': ((parent.width() / 2) - ($(this).outerWidth() / 2)) + 'px',
            });
          	$(this).show();
        });
    }
}

/* Handle detect platform */
function handleDetectPlatform() {
    /* DETECT PLATFORM */
    $.support.touch = 'ontouchend' in document;

    if ($.support.touch) {
        touch = true;
        $('body').addClass('touch');
        clickEv = 'touchstart';
    }
    else {
        $('body').addClass('notouch');
        if (navigator.appVersion.indexOf("Mac") != -1) {
            if (navigator.userAgent.indexOf("Safari") > -1) {
                $('body').addClass('macos');
            }
            else if (navigator.userAgent.indexOf("Chrome") > -1) {
                $('body').addClass('macos-chrome');
            }
            else if (navigator.userAgent.indexOf("Mozilla") > -1) {
                $('body').addClass('macos-mozilla');
            }
        }
    }
}

/* Handle product quantity */
function handleQuantity() {
    if ($('.quantity-wrapper').length) {
        $('.quantity-wrapper').on(clickEv, '.qty-up', function () {
            var $this = $(this);

            var qty = $this.data('src');
            if ($(qty).data('max') == 0 || ($(qty).data('max') > 0 && $(qty).val() < $(qty).data('max'))) {
                $(qty).val(parseInt($(qty).val()) + 1);
            }
        });
        $('.quantity-wrapper').on(clickEv, '.qty-down', function () {
            var $this = $(this);

            var qty = $this.data('src');

            if (parseInt($(qty).val()) > 1)
                $(qty).val(parseInt($(qty).val()) - 1);
        });
    }
}


/* Function update scroll product thumbs */
function updateScrollThumbsQS() {
    if ($('#gallery_main_qs').length) {

        $('#quick-shop-image .fancybox').on(clickEv, function () {
            var _items = [];
            var _index = 0;
            var product_images = $('#gallery_main_qs .image-thumb');
            product_images.each(function (key, val) {
                _items.push({'href': val.href, 'title': val.title});
                if ($(this).hasClass('active')) {
                    _index = key;
                }
            });
            $.fancybox(_items, {
                closeBtn: true,
                index: _index,
                helpers: {
                    buttons: {}
                }
            });
            return false;
        });

        $('#quick-shop-image').on(clickEv, '.image-thumb', function () {

            var $this = $(this);
            var background = $('.product-image .main-image .main-image-bg');
            var parent = $this.parents('.product-image-wrapper');
            var src_original = $this.attr('data-image-zoom');
            var src_display = $this.attr('data-image');

            background.show();

            parent.find('.image-thumb').removeClass('active');
            $this.addClass('active');

            parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
            parent.find('.main-image').find('img').attr('src', src_display).load(function () {
                background.hide();
            });

            return false;
        });
    }
}


function handleZoom() {
  var zoomImage = $('.elevatezoom');

      zoomImage.elevateZoom({
        gallery:'gallery_main', 
        galleryActiveClass: 'active', 
        //zoomType : "inner",
        //cursor: "crosshair",
        //responsive: true
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: true,
        easing : true
      });
      
      zoomImage.on("load",function() { 
          var mainImgHeight=$(this).height();            
          //$(".zoomWindow").css({"height":mainImgHeight});
          $(".zoomContainer").css({"height":mainImgHeight});
      });  
  

    //pass the images to Fancybox
    $(".elevatezoom .img-zoom").bind("click", function (e) {
        var ez = $('.elevatezoom .img-zoom').data('elevateZoom');
        $.fancybox(ez.getGalleryList(), {
            closeBtn: false,
            helpers: {
                buttons: {}
            }
        });
        return false;
    });
}

$(window).resize(function () {
    positionQuickshop();
});


jQuery(document).ready(function ($) {
    handleDetectPlatform();
    updateScrollThumbsQS();
    positionQuickshop();

    handleQuantity();


});

// Image is already loaded
handleZoom();
